import React, { useEffect } from 'react'
import { connect } from 'dva'
import PropTypes from 'prop-types'

import { CONTAINER_IDS } from '../../../../lib/constants'
import { setScrollPosition } from '../../../../lib/utils'
import actions from './actions'
import Button from '../../../Button'
import CollectionListItem from '../../../CollectionListItem'
import CreateCollectionsModal from '../../../Modals/CreateCollectionModal'
import ghAnalytics from '../../../../lib/analytics'
import GHAnimatedLogo from '../../../../assets/svg/GHAnimatedLogo'
import Loader from '../../../Loader'
import NoUserData from './NoUserData'
import SidebarBody from '../../SidebarBody'
import styles from './SavedHunt.module.scss'

function SavedHuntTabContent(props) {
  useEffect(() => {
    props.setHasScrollBar(CONTAINER_IDS.sidebarBody)
    if (props.scrollPosition) {
      setScrollPosition(props.scrollPosition)
    }
  }, [props.isLoading, props.isLoadingMoreCollections])

  const createCollectionsModal = e => {
    props.displayModal(CreateCollectionsModal)
    ghAnalytics.logCollectionStarted()
  }

  return (
    <>
      {props.isLoadingMoreCollections ? (
        <div className={styles.ghLoader}>
          <GHAnimatedLogo width={72} height={108} />
          <p>Loading hunts...</p>
        </div>
      ) : (
        <>
          <div className={styles.createBar}>
            <Button disabled={props.isDisabled} onClick={createCollectionsModal} theme={Button.THEME.outlinePrimary}>
              Create New Hunt
            </Button>
          </div>
          <div className={styles.listHeader} />
          <SidebarBody className={`${styles.bodyContainer} ${props.hasScrollBar && styles.scrollBar}`}>
            {props.isLoading ? (
              <div className={styles.loader}>
                <Loader active={true} />
                {props.loaderText}
              </div>
            ) : props.collectionsList.length > 0 ? (
              props.collectionsList.map((cl, i) => {
                return <CollectionListItem active={cl.active} collection={cl} key={i} onClick={() => props.collectionClicked(cl)} />
              })
            ) : (
              <NoUserData {...props} />
            )}
          </SidebarBody>
        </>
      )}
    </>
  )
}

SavedHuntTabContent.propTypes = {
  collectionsList: PropTypes.array,
  hasScrollBar: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  isLoadingMoreCollections: PropTypes.bool,
  loaderText: PropTypes.string,
  scrollPosition: PropTypes.string,
  // actions
  createCollectionsModal: PropTypes.func,
  displayModal: PropTypes.func,
  collectionClicked: PropTypes.func,
  gotoSidebarWithHistory: PropTypes.func,
  setHasScrollBar: PropTypes.func
}

export default connect(model => {
  const { collectionsList, collectionsLoading, moreCollectionsLoading: isLoadingMoreCollections, preferences } = model.collections
  const { sidebarHasScrollBar, sideBarScrollPosition } = model.app
  const hasScrollBar = sidebarHasScrollBar
  const isDisabled = isLoading || isLoadingMoreCollections
  const isLoading = collectionsLoading || isLoadingMoreCollections
  const loaderText = 'Loading Hunts...'
  const scrollPosition = sideBarScrollPosition.hunts

  if (!isLoading && collectionsList.length > 0) {
    if (preferences.pinned) {
      let pinnedCollectionIndex = -1
      for (let li = 0; li < collectionsList.length; li++) {
        collectionsList[li].active = collectionsList[li].uuid === preferences.pinned
        if (collectionsList[li].active) {
          pinnedCollectionIndex = li
        }
      }
      if (pinnedCollectionIndex > 0) {
        const collection = collectionsList.splice(pinnedCollectionIndex, 1)[0]
        collectionsList.unshift(collection)
      }
    }
  }
  return {
    collectionsList,
    collectionsLoading,
    hasScrollBar,
    scrollPosition,
    isDisabled,
    isLoading,
    isLoadingMoreCollections,
    loaderText
  }
}, actions)(SavedHuntTabContent)
